import React from 'react';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import { Button, Hr, InfoBox } from 'LocalGluons';
import { t } from 'Locale';
import defaultStyles from '../PageStyles.jss';

const SendCode = ({
    onGetVerificationCode,
    errorMessage,
    children,
    title,
    description,
    buttonDisabled,
    close
}) => (
    <View style={defaultStyles.container}>
        <Text style={defaultStyles.title}>{title}</Text>
        <Hr />
        {!!errorMessage && <InfoBox style={defaultStyles.infoBox} message={errorMessage} />}
        <Text style={defaultStyles.description} numberOfLines={5}>
            {description}
        </Text>
        {children}
        <View style={defaultStyles.buttonWidth}>
            <Button
                style={defaultStyles.button}
                title={t('COMMON.GET_VERIFICATION_CODE')}
                onPress={onGetVerificationCode}
                isDisabled={buttonDisabled}
                testID="send_code"
            />
            <View style={{ height: 14 }}></View>
            <Button
                onPress={close}
                style={{ marginTop: 14 }}
                title={t('PARTNER.VOYO.CLOSE_BTN')}
                isSecondary
            />
        </View>
    </View>
);

SendCode.defaultProps = {
    errorMessage: '',
    children: null,
    buttonDisabled: false
};

SendCode.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    onGetVerificationCode: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    buttonDisabled: PropTypes.bool
};

export default SendCode;
